var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2A37",
    d: "M11.525 1.306a.75.75 0 0 1 .92-.53 8.08 8.08 0 0 1 5.78 5.78.751.751 0 1 1-1.45.388 6.6 6.6 0 0 0-4.718-4.72.75.75 0 0 1-.532-.918m-.218 3.919C12.6 5.57 13.43 6.4 13.775 7.694a.75.75 0 0 0 1.45-.388c-.48-1.796-1.735-3.05-3.53-3.53a.75.75 0 0 0-.388 1.449m6.79 7.38-4.416-1.979-.013-.005a1.5 1.5 0 0 0-1.492.184L9.894 12.75c-1.446-.702-2.938-2.184-3.64-3.61l1.948-2.317q.028-.035.053-.072a1.5 1.5 0 0 0 .124-1.412v-.011L6.394.904A1.5 1.5 0 0 0 4.836.01 5.274 5.274 0 0 0 .25 5.25c0 7.444 6.056 13.5 13.5 13.5a5.274 5.274 0 0 0 5.239-4.586 1.5 1.5 0 0 0-.892-1.559"
  })));
};
export default SvgPhone;